import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Result, ResultList, SubTaskInput, SubTaskResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class SubTaskService {

  constructor(private httpClient: HttpClient) { }

  public addSubTask(subTaskInput: SubTaskInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'SubTask/AddSubTask', subTaskInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editSubTaskStatus(id: number, isDone: boolean): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'SubTask/EditSubTaskStatus?id=' + id, isDone, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editSubTask(id: number, subTaskInput: SubTaskInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'SubTask/EditSubTask?id=' + id, subTaskInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateSubtaskAssignee(id: number, employeeId: number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'SubTask/UpdateSubtaskAssignee?id=' + id, employeeId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteSubTask(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'SubTask/DeleteSubTask?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getSubTasks(ticketId: number): Promise<ResultList<SubTaskResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'SubTask/GetSubTasks?ticketId=' + ticketId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<SubTaskResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<SubTaskResult>(), result.error));
  }
}
